module.exports = __webpack_public_path__ + "static/water-place-summer-fd33f05a836d4fa1b118bba61be14f0f.jpg";